import { makeStyles } from "@mui/styles"

const useStyle = makeStyles(() => ({
  row: {
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#f9f9f9",
    boxShadow: "inset 0 -2px 0 #00a78f",
  },
  headStatus: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "40%",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
    "@media all and (max-width: 600px)": {
      fontSize: 12,
    },
  },
  headCuit: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "15%",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
    "@media all and (max-width: 600px)": {
      fontSize: 12,
      padding: "0px 10px",
    },
  },
  headDate: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "@media all and (max-width: 1090px)": {
      display: "none",
    },
  },
  headKebab: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "5%",
    textAlign: "start",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
}))

export default useStyle
